import React from "react";
import { IconT } from "types/utils";
import { theme } from "styles/themes";

const EnterpriseAvatarIcon = ({ fill = theme.colors["picton-blue"], width = 24, height = 24 }: IconT) => {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="23" height="23" rx="11.5" fill={fill} fillOpacity="0.08" />
      <rect x="0.5" y="0.5" width="23" height="23" rx="11.5" stroke={fill} />
      <path
        d="M8.01136 17.5V5.86364H15.8523V7.89205H10.4716V10.6648H15.4489V12.6932H10.4716V15.4716H15.875V17.5H8.01136Z"
        fill={fill}
      />
    </svg>
  );
};

export default EnterpriseAvatarIcon;
